<template>
  <div>

    <!-- 内容页 background: url() no-repeat center  50%/cover-->
    <div class="container ny_content">
      <div class="ny_nav">
        <div class="ny_nav_h">
          <div>
            <h2>公司简介</h2>
            <p>ABOUT US</p>
          </div>
        </div>
        <div class="ny_nav_dqwz">
          当前位置：<span class="hidden-xs">关于我们></span>公司简介
        </div>
      </div>
      <div class="ny_view">
        <div class="ny_gsjj">
          <h2>公司简介</h2>
          <div class="ny_gsjj_content">
            <div>
              <img v-for="(i_item,i_index) in introduceList.filePath" :key="i_index" :src="i_item.url" style="float: right;margin: 0 35px">
            </div>
            <p v-html="introduceList.content"></p>
          </div>
        </div>
        <div class="ny_gsjj">
          <h2>公司资质</h2>
          <div class="ny_gsjj_content">
            <div class="row" id="gszz">
              <viewer  class="col-md-3 col-sm-4 col-xs-6" v-for="(z_item,z_index) in introduceList.qualifications" :key="z_index">
                <div class="gszz_img">
                  <!-- background: url(img/gszz1.jpg) no-repeat left center;background-size: 100% auto;-->
                  <img class="gszz_img_bg" :src="z_item.url" style="cursor:pointer"/>
<!--                  <div :style="{background:'url('+z_item.url+') no-repeat center 50%/cover',backgroundSize:'100%'}">-->
<!--                  </div>-->
                </div>
              </viewer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data(){
    return{
      introduceList:[]
    }
  },
  created () {
    this.getIntroduceList()
  },
  methods:{
    async getIntroduceList(){
      const {data:res} = await this.$http.get('home/introduce_list');
      if (res.code !== 200) return false
      this.introduceList = res.data.content
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/about/company/index.vue